import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { FaCheck } from 'react-icons/fa';
import { FcCancel } from 'react-icons/fc';

const style = {
  tableCell: {
    fontWeight: 'bold',
  },
};

const EquipoEstadoComponent = ({ equipo }) => {
  return (
    <TableCell align="center">
      {equipo === null ? <b>N/A</b> : equipo ? <FaCheck color="green" fontSize={24} /> : <FcCancel fontSize={24} />}
    </TableCell>
  );
};

export const EquiposPendientesModal = ({ open: { open, asignacionesPendientes = {} }, setOpen }) => {
  const { pc, flota, telefonoFijo } = asignacionesPendientes;

  return (
    <Dialog PaperProps={{ sx: { width: '40%', height: '40%' } }} open={open} maxWidth="lg">
      <DialogTitle sx={{ textTransform: 'uppercase' }} className="text-mem text-center">
        Asignaciones Pendientes
      </DialogTitle>
      <Divider />

      <DialogContent>
        <Table component={Paper}>
          <TableHead>
            <TableRow>
              <TableCell sx={style.tableCell}>Equipo</TableCell>
              <TableCell align="center" sx={style.tableCell}>
                Entregado
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>PC</TableCell>
              <EquipoEstadoComponent equipo={pc} />
            </TableRow>
            <TableRow>
              <TableCell>Flota</TableCell>
              <EquipoEstadoComponent equipo={flota} />
            </TableRow>
            <TableRow>
              <TableCell>Teléfono Fijo</TableCell>
              <EquipoEstadoComponent equipo={telefonoFijo} />
            </TableRow>
          </TableBody>
        </Table>
      </DialogContent>

      <Divider />

      <DialogActions className="justify-content-center">
        <button onClick={() => setOpen({ open: false, asignacionesPendientes: {} })} id="btn-cancelar" type="button" className="btn btn-danger">
          <DoNotDisturbAltIcon sx={{ marginTop: -0.5, marginRight: 0.5 }} />
          CANCELAR
        </button>
      </DialogActions>
    </Dialog>
  );
};
